import { AccountBox, DocumentScannerOutlined, SpatialAudioOffSharp } from "@mui/icons-material";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

import { formatDateTime } from "../../../utils/utils";
import { MarketResearchStudy } from "../models";
import useMarketResearchStore from "../useMarketResearchStore";
import { grey, indigo } from "../../../colors";

export type InterviewComponentProps = {
  study: MarketResearchStudy;
  respondentIds?: Record<string, string>[];
  sx?: object;
};

export default function InterviewComponent({ study, respondentIds, sx }: InterviewComponentProps) {
  const { navigate } = useMarketResearchStore();

  const numOfRespondents = respondentIds?.length || study.num_respondents;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", ...sx }}>
      <Box sx={{ display: "none", gap: "0.5rem" }} alignItems={"center"}>
        <AccountBox />
        <Typography variant="h6" sx={{ fontSize: "20px", color: indigo[900] }}>
          Interviews
        </Typography>
      </Box>
      <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
        <Box sx={{ display: "flex", gap: "0.5rem" }} alignItems={"center"}>
          <Typography sx={{ fontSize: "10px", fontWeight: 600, letterSpacing: "0.05em", color: grey[600] }}>
            FIELDED
          </Typography>
          <Typography sx={{ fontSize: "13px", color: indigo[900] }}>
            {formatDateTime(study.study_date, "MMMM DD, YYYY")}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          padding: "0.3rem 0.75rem",
          backgroundColor: indigo[100],
          borderRadius: "16px",
          width: "fit-content",
          display: !study.num_respondents ? "none" : "flex",
          justifyContent: "center",
          alignItems: "center",
          my: "1em",
        }}
      >
        <Typography sx={{ fontSize: "13px", fontWeight: 500, color: indigo[900] }}>
          {`${numOfRespondents} Respondents`}
        </Typography>
      </Box>
      {respondentIds && respondentIds?.length > 0 && (
        <>
          <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center", my: "1rem" }}>
            <Box
              sx={{
                width: "44px",
                height: "44px",
                backgroundColor: indigo[100],
                borderRadius: "12px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <SpatialAudioOffSharp sx={{ color: indigo[900] }} />
            </Box>
            <Typography sx={{ fontSize: "18px", fontWeight: 600, color: indigo[900] }}>Interviews</Typography>
          </Box>
          <Box sx={{ flex: 1, overflow: "auto" }}>
            {respondentIds?.map(({ id: respondentId, respondent_guid }, i) => {
              return (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: "0.5rem",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={true}
                        defaultChecked
                        sx={{ color: grey[300], "&.Mui-checked": { color: indigo[700] } }}
                      />
                    }
                    label={<Typography sx={{ fontSize: 13, color: grey[700] }}>{respondentId}</Typography>}
                  />
                  <Box sx={{ display: "flex", gap: "0.5rem" }}>
                    {/* <SpatialAudioOffOutlined fontSize="small" /> */}
                    <DocumentScannerOutlined
                      sx={{ cursor: "pointer", color: indigo[700] }}
                      fontSize="small"
                      onClick={() => {
                        // setRespondentId(respondentId);
                        navigate(`/market-research/study/${study.study_guid}/transcript/${respondent_guid}`, {
                          state: { fromRightPanel: true },
                        });
                      }}
                    />
                  </Box>
                </Box>
              );
            })}
          </Box>
        </>
      )}
    </Box>
  );
}
